<div class="scrollable-container">
  <div
    *ngFor="let device of installationsStore.selectMainDevicesAndOrderTiles(installationId) | async"
  >
    <app-main-devices-tile
      [installationId]="installationId"
      [device]="device"
    ></app-main-devices-tile>
  </div>
</div>
